import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Autocomplete from "@mui/material/Autocomplete";

const AssetTransfer = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [assetData, setAssetData] = useState(null);

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [remarks, setRemarks] = useState("");

  const { API_CONFIG } = require("../configuration");

  useEffect(() => {
    fetchInitialData();
  }, [assetId]);

  const fetchInitialData = async () => {
    try {
      const tokenlocal = localStorage.getItem("token");
      setLoading(true);

      const [assetRes, branchRes] = await Promise.all([
        //   const [assetRes, branchRes] = await Promise.all([
        //     axios.get(
        //       `${API_CONFIG.APIURL}/assignasset/details/${encodedAssetIds}`,
        //       {
        //         headers: { Authorization: `Bearer ${tokenlocal}` },
        //       },
        //     ),
        axios.get(
          `${API_CONFIG.APIURL}/assignasset/details/${encodeURIComponent(assetId)}`,
          {
            headers: { Authorization: `Bearer ${tokenlocal}` },
          },
        ),
        axios.get(`${API_CONFIG.APIURL}/employee/branches`, {
          headers: { Authorization: `Bearer ${tokenlocal}` },
        }),
      ]);
      console.log("assets: ", assetRes);
      console.log("branch: ", branchRes.data);

      setAssetData(assetRes.data);
      setBranches(branchRes.data.data || []);
    } catch (error) {
      console.error(error);
      alert("Failed to load asset details");
    } finally {
      setLoading(false);
    }
  };

  const handleTransfer = async () => {
    if (!selectedBranch) {
      alert("Please select branch");
      return;
    }

    if (!selectedEmployee) {
      alert("Please select employee");
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = {
        asset_id: assetId,
        transfer_to: selectedEmployee,
        transfer_branch: selectedBranch,
        remarks,
        requested_by: user?.emp_id,
      };

      const response = await axios.post(
        `${API_CONFIG.APIURL}/assettransfer/transfer`,
        payload,
      );

      if (response.data.success) {
        alert("Asset transferred successfully");
        navigate(-1);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Failed to transfer asset");
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 10,
          }}
        >
          <CircularProgress />
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box
        sx={{
          p: 3,
          ml: { xs: 0, md: "250px" },
          boxSizing: "border-box",
          overflowX: "hidden",
          backgroundColor: "#F4F6F8",
          minHeight: "100vh",
        }}
      >
        <Paper
          sx={{
            p: 4,
            maxWidth: 1200,
            mx: "auto",
            borderRadius: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 3,
              fontWeight: 700,
            }}
          >
            Transfer Asset
          </Typography>

          {/* Asset Details */}

          <Typography variant="h6" sx={{ mb: 2 }}>
            Asset Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Typography variant="subtitle2" color="text.secondary">
                Asset ID
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {assetData?.asset_id || "-"}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle2" color="text.secondary">
                Brand
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {assetData?.brand || "-"}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle2" color="text.secondary">
                Model
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {assetData?.model || "-"}
              </Typography>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography variant="subtitle2" color="text.secondary">
                Serial Number
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {assetData?.imei_num || "-"}
              </Typography>
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
            Transfer To
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={branches}
                getOptionLabel={(option) =>
                  `${option.branch_id} - ${option.branch_name}`
                }
                value={
                  branches.find(
                    (b) =>
                      `${b.branch_id} - ${b.branch_name}` === selectedBranch,
                  ) || null
                }
                onChange={(event, newValue) => {
                  const value = newValue
                    ? `${newValue.branch_id} - ${newValue.branch_name}`
                    : "";

                  setSelectedBranch(value);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Branch" fullWidth />
                )}
              />
            </Grid>
            <Grid item item xs={12} md={6}>
              <TextField
                label="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                multiline
                rows={2}
                fullWidth
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              mt: 4,
              display: "flex",
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleTransfer}
            >
              Transfer Asset
            </Button>

            <Button variant="outlined" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default AssetTransfer;
